<template>
  <div class="content">
    <div class="md-layout md-alignment-center">
      <div
        class="md-layout-item md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Checkout</h4>
          </md-card-header>
          <md-card-content>
            <div class="errors mx-5">{{ error }}</div>
            <div class="md-layout">
              <div class="md-layout-item">
                <md-steppers :md-active-step.sync="active" md-vertical>
                  <md-step
                    id="first"
                    md-label="Billing &amp; Shipping"
                    md-description="Billing &amp; Shipping Details"
                    :md-done.sync="first"
                  >
                    <div class="md-layout-item md-size-100">
                      <billing-shipping-form ref="billingForm" />
                      <md-button
                        class="md-primary mt-3"
                        @click="setDone('first', 'second')"
                      >
                        Continue
                      </md-button>
                    </div>
                  </md-step>
                  <md-step
                    id="second"
                    md-label="Payment"
                    md-description="Payment Details"
                    :md-done.sync="second"
                  >
                    <div
                      class="md-layout-item md-size-100 md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-100 md-xlarge-size-60"
                    >
                      <credit-card-form ref="cardForm" />
                    </div>
                    <div
                      class="md-layout-item md-size-100 d-flex align-items-center"
                    >
                      <md-button
                        class="md-primary"
                        :disabled="loading"
                        @click="setDone('second')"
                      >
                        Confirm &amp; Pay
                      </md-button>
                      <md-progress-spinner
                        class="mx-3"
                        :md-diameter="30"
                        :md-stroke="loading ? 4 : 0"
                        md-mode="indeterminate"
                      ></md-progress-spinner>
                    </div>
                  </md-step>
                </md-steppers>
              </div>
              <div
                class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-large-size-40 md-xlarge-size-30"
              >
                <order-summary-table class="my-3" />
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import BillingShippingForm from "../Forms/BillingShippingForm.vue";
import CreditCardForm from "../Forms/creditCardForm.vue";
import OrderSummaryTable from "../Tables/orderSummaryTable.vue";
import ApiService from "@/services/api";

export default {
  components: {
    CreditCardForm,
    OrderSummaryTable,
    BillingShippingForm
  },
  data() {
    return {
      active: "first",
      first: false,
      second: false,
      error: "",
      loading: false,

      userData: null
    };
  },
  methods: {
    setDone(id, index) {
      if (id === "first" && !this.$refs.billingForm.completed()) return;

      this[id] = true;
      if (index) {
        this.active = index;
      }

      if (this.second) {
        this.loading = true;

        this.setUserData();

        this.$refs.cardForm
          .createPayMethodId()
          .then(payMethodId => {
            this.submit(payMethodId);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    setUserData() {
      const user = this.$refs.billingForm.user;
      const business = this.$refs.billingForm.business;

      this.userData = {
        title: user.title,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        mobile_number: user.mobile_number,
        billing_address: {
          street: business.business_address,
          suburb: business.business_address_suburb,
          state: business.business_address_state,
          postcode: business.business_address_postcode
        },
        postal_address: {
          street: business.postal_address,
          suburb: business.postal_address_suburb,
          state: business.postal_address_state,
          postcode: business.postal_address_postcode
        }
      };
    },
    submit(payMethodId) {
      let passes = [];
      this.$store.getters.cart.forEach(item => {
        passes.push({
          user_id: item.id,
          pass_type: item.new_pass.type
        });
      });

      let data = {
        pay_method_id: payMethodId,
        passes: passes,
        billing_user: this.userData
      };

      ApiService.user
        .renewPasses(data)
        .then(response => {
          this.$store.dispatch("clearCart");
          this.$store.dispatch("getAuthUser");

          this.$toast.success("Your new passes were added successfully.");

          this.$store
            .dispatch("setLastPurchase", response.data.data.passes)
            .then(() => {
              // this.$router.push("/access-passes");
              this.$router.push("/order-confirmation");
            });
        })
        .catch(error => {
          this.error = error.response.data.message;
          this.loading = false;

          if (
            error.response.data.data.error === "current_pass_not_renewable_yet"
          ) {
            this.error += ": " + error.response.data.data.user_id;
          }

          this.$toast.error(this.error);
        });
    }
  }
};
</script>
